export default __webpack_public_path__ + "static/media/search-not-found.f5b0431b.png";